import { gql } from '@apollo/client';
import { SYSTEM } from '../../../components/myeirconstant/myEirConstant';

const { MY_EIR } = SYSTEM;
const ENDPOINT = {
    USER_OTC: gql`
        query userOtc($accessToken: String!, $systemId: String!) {
            userOtc(accessToken: $accessToken, systemId: $systemId) {
                accountnumber
                onetimecode
                isION
                isR6
                ionServices
            }
        }
    `,
};

export const getUserOtc = async ({ graphql }) => {
    try {
        const response = await graphql.query({
            query: ENDPOINT.USER_OTC,
            variables: {
                accessToken: sessionStorage.getItem('access_token'),
                systemId: MY_EIR,
            },
        });
        return response;
    } catch (error) {
        throw new Error(error);
    }
};
